import React from 'react';
import PropTypes from 'prop-types';

// import hooks
import useKenwoodClosingFilters from '@/hooks/listing/Kenwood/useKenwoodClosingFilters';

const SortMobileFilter = ({
  areMobileFiltersOpen,
  sorts,
  sortByLabel,
  onApplySort,
}) => {
  const selectedSort = sorts.find(sort => sort.selected);
  const checkboxRef = useKenwoodClosingFilters(areMobileFiltersOpen);
  return (
    <section className='ken-simple-css-accordion'>
      <input ref={checkboxRef} type='checkbox' id='sortByMobile' />
      <div className='ken-simple-css-accordion__wrapper'>
        <label
          htmlFor='sortByMobile'
          className='ken-simple-css-accordion__title'
        >
          <span className='ken-simple-css-accordion__label --multi-label'>
            {sortByLabel}
          </span>
          <span className='ken-simple-css-accordion__second-label'>
            {selectedSort?.name}
          </span>
          <i className='ken-simple-css-accordion__icon' />
        </label>
        <div className='ken-simple-css-accordion__content'>
          {sorts.map(sort => (
            <button
              key={sort.code}
              className={`ken-plp__filters__facet-value --no-border ${
                sort.selected ? ' --selected' : ''
              }`}
              type='button'
              onClick={() => !sort.selected && onApplySort(sort.code)}
            >
              {sort.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

SortMobileFilter.propTypes = {
  areMobileFiltersOpen: PropTypes.bool,
  sorts: PropTypes.arrayOf(PropTypes.shape()),
  sortByLabel: PropTypes.string.isRequired,
  onApplySort: PropTypes.func,
};

SortMobileFilter.defaultProps = {
  areMobileFiltersOpen: false,
  sorts: [],
  onApplySort: null,
};

export default SortMobileFilter;
